import React from 'react';
import {
  Datagrid,
  TextField,
  ReferenceField,
  DateField,
  Responsive,
  SimpleList,
  translate,
  resolveBrowserLocale,
  FunctionField,
  Labeled
} from 'react-admin';
import EditableContributionField from './EditableContributionField';
import ApproveButton from '../contributions/ApproveButton';
import DeleteButton from '../contributions/DeleteButton';
import { GetDuration, ModifyString } from '../methods';
const getDuration = new GetDuration();
const modifyString = new ModifyString();

let ContributionTab = props => {
  const {
    record: mission,
    translate,
    resource,
    id,
    roleLevel,
    ...rest
  } = props;

  if (mission) {
    const { users, missions } = mission;

    let contributions = mission.contributions;

    if (users) {
      let contribs = [];
      contribs = missions.reduce((reduced, mission) => {
        if (mission.contributions) {
          const contributions = Object.entries(mission.contributions).map(
            entry =>
              Object.assign(
                {},
                {
                  id: entry[0],
                  missionId: mission.id
                },
                entry[1]
              )
          );

          reduced = reduced.concat(contributions);
        }
        return reduced;
      }, []);

      let usersIds = users.map(user => user.id);
      contributions = contribs.filter(contrib =>
        usersIds.includes(contrib.userId)
      );

      let obj = {};
      for (const contribution of contributions) {
        const { id, missionId, ...rest } = contribution;
        obj[id] = rest;
        obj[id].missionId = missionId;
      }
      contributions = obj;
    }

    return contributions ? (
      [
        <Labeled key={1} label="infos">
          <FunctionField
            {...rest}
            record={mission}
            // label="infos"
            render={({ contributions: contributionFromProps }) => {
              return translate('contributions.total_duration_x', {
                company: mission.name
                  ? modifyString.capitalizeFirstLetter(mission.name)
                  : mission.title,
                duration: getDuration.getAllDuration(
                  contributionFromProps || contributions
                )
              });
            }}
          />
        </Labeled>,
        <ContributionsGrid
          key={2}
          id={id}
          contributions={contributions}
          {...props}
        />
      ]
    ) : (
      <div>
        <p> {translate('contributions.empty')} </p>
      </div>
    );
  }
  return;
};

let renderMissionsGrid = ({ record, translate, id }) => {
  if (record && record.missionId) {
    return (
      <ReferenceField
        record={record}
        source="missionId"
        reference="missions"
        basePath="/missions"
        sortable={false}
        allowEmpty
        linkType="show"
      >
        <TextField source="title" />
      </ReferenceField>
    );
  } else {
    record.missionId = id;
    return (
      <ReferenceField
        record={record}
        source="missionId"
        reference="missions"
        basePath="/missions"
        sortable={false}
        allowEmpty
        linkType="show"
      >
        <TextField source="title" />
      </ReferenceField>
    );
  }
};

let ContributionsGrid = props => {
  const {
    record: mission,
    contributions,
    translate,
    resource,
    id,
    roleLevel,
    ...rest
  } = props;
  const locales = resolveBrowserLocale();
  let data = {};
  let ids = [];

  if (mission.contributions || contributions) {
    let contributionsData = mission.contributions || contributions;

    ids = Object.keys(contributionsData);
    data = contributionsData;
    Object.entries(contributionsData).forEach(
      entry => (contributionsData[entry[0]].id = entry[0])
    );

    return (
      <Responsive
        small={
          <SimpleList
            ids={ids}
            data={data}
            onToggleItem={() => {}}
            linkType={false}
            {...rest}
            // record={mission}
            resource="contributions"
            total={ids.length}
            leftIcon={record => (
              <ApproveButton
                translate={translate}
                missionId={mission.id}
                record={record}
                label="validate"
                roleLevel={roleLevel}
              />
            )}
            primaryText={record => (
              <ReferenceField
                label="users"
                source="userId"
                reference="users"
                basePath="/users"
                record={record}
                allowEmpty
                linkType="show"
              >
                <TextField source="name" />
              </ReferenceField>
            )}
            secondaryText={record => (
              <span>
                <DateField
                  source="start"
                  sortable={false}
                  locales={locales}
                  record={record}
                  options={{
                    day: 'numeric',
                    year: 'numeric',
                    month: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric'
                  }}
                />
                <EditableContributionField
                  roleLevel={roleLevel}
                  contribution={record}
                  translate={translate}
                />
              </span>
            )}
            // tertiaryText={record => (
            //   <FunctionField
            //     label="duration"
            //     record={record}
            //     render={contribution => (
            //       <EditableContributionField
            //         roleLevel={roleLevel}
            //         contribution={contribution}
            //         translate={translate}
            //       />
            //     )}
            //   />
            // )}
            rightIcon={record => (
              <DeleteButton
                missionId={data.id}
                record={record}
                label="validate"
                roleLevel={roleLevel}
              />
            )}
          />
        }
        medium={
          <Datagrid
            record={mission}
            ids={ids}
            data={data}
            {...rest}
            resource="contributions"
            currentSort={{}}
          >
            <ApproveButton
              translate={translate}
              missionId={mission.id}
              roleLevel={roleLevel}
              addLabel={false}
              record={mission}
            />
            <ReferenceField
              label={translate('resources.users.name', 1)}
              source="userId"
              reference="users"
              basePath="/users"
              sortable={false}
              allowEmpty
              linkType="show"
            >
              <TextField source="name" />
            </ReferenceField>
            <FunctionField
              label={translate('resources.missions.name', 2)}
              render={record =>
                renderMissionsGrid({
                  record,
                  translate,
                  id
                })
              }
            />
            <DateField
              source="start"
              sortable={false}
              locales={locales}
              options={{
                weekday: 'long',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
              }}
            />
            <FunctionField
              label="duration"
              render={
                contribution => (
                  <EditableContributionField
                    contribution={contribution}
                    translate={translate}
                    roleLevel={roleLevel}
                  />
                )
                //renderDurationField(contribution, translate)
              }
            />
            <DeleteButton
              missionId={mission.id}
              roleLevel={roleLevel}
              addLabel={false}
            />
          </Datagrid>
        }
      />
    );
  }
};

ContributionTab = translate(ContributionTab);
ContributionsGrid = translate(ContributionsGrid);

export { ContributionTab };



// WEBPACK FOOTER //
// ./src/contributions/ContributionTab.js